import React, { FC, useRef, useState } from "react";
import { Loc } from "../../App/Loc";
import { Box, HStack, Pressable, CloseIcon, Text, VStack } from "native-base";
import { StyleSheet } from "react-native";
import settings from "../../Platform/settings.json";
import { Media, Person } from "../../AVCore/AVCore";
import { VideoIcon } from "../../assets/icons/icon-assets";
import LinkPreview from "../../components/common/preview/LinkPreview";
import MP3Icon from "../../assets/images/MP3ICON.png";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";

const CreatePostGrid = ({
  images,
  setImages,
  videos,
  setvideos,
  media,
  setMedia,
  allMedia,
  setAllMedia,
  links,
  setLinks,
  setOneDriveLink,
  oneDriveLink,
  pdf,
  setpdf,
  setShowPreview,
  setSingleImage,
  setShowAllImage,
  setIsLoading,
  selectedItem,
  setIsConfirmDelete,
  handleConfirmDelete,
}) => {
  const [itemList, setItemList] = useState<any>([]);

  const Grid2styles = StyleSheet.create({
    container: { flex: 1, flexDirection: "row", flexWrap: "wrap" },
    img1: {
      borderColor: "#fff",
      borderWidth: 1,
      width: 260,
      height: 160,
    },
    img2: {
      borderColor: "#fff",
      borderWidth: 1,
      width: 140,
      height: 160,
    },
  });

  const handleCancelDoc = (pdfs) => {
    setpdf(pdf.filter((f) => f != pdfs));
    setMedia(media.filter((f) => f.id !== pdfs.id));
  };

  const handleDocument = async (item) => {
    if (item?.type.startsWith("image") || item?.type.startsWith("video")) {
      //const mediaItems = item.filter(
      // (item) => item?.type.startsWith("image") || item?.type.startsWith("video")
      //);
      itemList?.push(item);
      setItemList(itemList);
      openPreview(item, itemList);
      return;
    }
  };

  // Function to render media items
  const openPreview = (item, items) => {
    setShowPreview(true);
    setSingleImage(item);
    setShowAllImage(items);
  };

  return (
    <>
      <div className="add_pics_inside1 p0">
        {(images.length > 0 ||
          videos.length > 0 ||
          links?.length > 0 ||
          oneDriveLink?.length > 0 ||
          pdf?.length > 0) && (
          <HStack
            alignContent={"center"}
            alignSelf={"center"}
            justifyContent={"center"}
            space={3}
          >
            {(images.length > 0 ||
              videos.length > 0 ||
              links?.length > 0 ||
              oneDriveLink?.length > 0 ||
              pdf?.length > 0) && (
              <Box style={Grid2styles.container}>
                {images.length > 0 &&
                  images?.slice(0, 20).map((media, i) => (
                    <HStack style={Grid2styles["img1"]} key={media.id || i}>
                      {media?.type?.startsWith("image") && (
                        <Pressable
                          position={"absolute"}
                          background={"rgba(151, 151, 151, 0.85)"}
                          borderRadius={"50px"}
                          top={"12px"}
                          right={"12px"}
                          padding={"10px"}
                          zIndex={4}
                          onPress={() => {
                            handleConfirmDelete(media);
                          }}
                        >
                          <CloseIcon color={"black"} size={"12px"} />
                        </Pressable>
                      )}

                      <img
                        width={260}
                        height={160}
                        style={{
                          borderRadius: 10,
                          objectFit: "contain",
                          backgroundColor: "#eeeeee",
                        }}
                        src={
                          (media?.type === "application/pdf" && settings.pdf) ||
                          ((media?.type === "application/msword" ||
                            media?.type ===
                              "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                            settings.word) ||
                          ((media?.type === "application/vnd.ms-powerpoint" ||
                            media?.type ===
                              "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                            settings.powerpoint) ||
                          ((media?.type === "application/vnd.ms-excel" ||
                            media?.type ===
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                            settings.excel) ||
                          ((media?.type === "text/plain" ||
                            media?.type === "text/plain") &&
                            settings.file) ||
                          Media.getURL(media)
                        }
                        key={media.id || i}
                        alt=""
                      />
                    </HStack>
                  ))}

                {videos.slice(0, 20).map((vid, i) => (
                  <Box
                    key={vid?.id || i}
                    position="relative"
                    width={260}
                    height={160}
                    borderRadius={10}
                    overflow="hidden"
                  >
                    <img
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                      src={Media.getVideoPicURL(vid)}
                      key={vid?.id || i}
                      alt=""
                    />

                    <HStack
                      position="absolute"
                      top="50%"
                      left="50%"
                      style={{
                        transform: [
                          { translateX: -30 }, // half of icon size (60px)
                          { translateY: -30 },
                        ],
                      }}
                      zIndex={2}
                    >
                      <VideoIcon size="60px" color="white" />
                    </HStack>

                    <Pressable
                      position="absolute"
                      background="rgba(151, 151, 151, 0.85)"
                      borderRadius="50px"
                      top="12px"
                      right="12px"
                      padding="10px"
                      zIndex={3}
                      onPress={() => {
                        handleConfirmDelete(vid);
                      }}
                    >
                      <CloseIcon color="black" size="12px" />
                    </Pressable>
                  </Box>
                ))}

                {pdf?.length > 0 &&
                  pdf?.slice(0, 20).map((pdfmedia, i) => (
                    <VStack key={pdfmedia?.id || i}>
                      <Pressable onPress={() => handleDocument(pdfmedia)}>
                        <HStack
                          style={Grid2styles["img2"]}
                          key={pdfmedia?.id || i}
                        >
                          <Pressable
                            position={"absolute"}
                            background={"#dcdc"}
                            borderRadius={"50px"}
                            zIndex={4}
                            padding={2}
                            right={0}
                            onPress={() => {
                              handleCancelDoc(pdfmedia);
                            }}
                          >
                            <CloseIcon color={"#fff"} size={5} />
                          </Pressable>

                          <img
                            width={"110px"}
                            height={"120px"}
                            src={
                              (pdfmedia?.type === "application/pdf" &&
                                settings?.pdf) ||
                              ((pdfmedia?.type ===
                                "application/vnd.ms-powerpoint" ||
                                pdfmedia?.type ===
                                  "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                                settings?.powerpoint) ||
                              ((pdfmedia?.type === "application/msword" ||
                                pdfmedia?.type ===
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                                settings?.word) ||
                              (pdfmedia?.type === "audio/wav" && MP3Icon) ||
                              ((pdfmedia?.type === "application/vnd.ms-excel" ||
                                pdfmedia?.type ===
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                pdfmedia?.type ===
                                  "application/octet-stream") &&
                                settings?.excel) ||
                              settings?.file
                            }
                            key={pdfmedia?.id || i}
                            alt=""
                          />
                        </HStack>

                        <Text
                          fontSize={"16px"}
                          fontWeight={400}
                          numberOfLines={1}
                          width={"100px"}
                        >
                          {pdfmedia?.orgFile}
                        </Text>
                      </Pressable>
                    </VStack>
                  ))}

                {links.slice(0, 20).map((vid, i) => (
                  <Box key={vid?.id || i}>
                    <HStack style={Grid2styles["img1"]} key={vid?.id || i}>
                      <Pressable
                        position={"absolute"}
                        background={"rgba(151, 151, 151, 0.85)"}
                        borderRadius={"50px"}
                        top={"12px"}
                        right={"12px"}
                        padding={"10px"}
                        zIndex={4}
                        onPress={() => {
                          handleConfirmDelete(vid);
                        }}
                      >
                        <CloseIcon color={"black"} size={"12px"} />
                      </Pressable>

                      {vid?.type == "iframe" ? (
                        <iframe
                          src={vid.linkURL}
                          height={"260"}
                          width={"260"}
                        ></iframe>
                      ) : (
                        <LinkPreview
                          url={vid.linkURL}
                          imageHeight={"60px"}
                          width={"260px"}
                          height={"160"}
                        />
                      )}
                    </HStack>
                  </Box>
                ))}

                {oneDriveLink.length > 0 &&
                  oneDriveLink?.slice(0, 20).map((media, i) => (
                    <HStack style={Grid2styles["img1"]} key={media?.id || i}>
                      <Pressable
                        position={"absolute"}
                        background={"rgba(151, 151, 151, 0.85)"}
                        borderRadius={"50px"}
                        top={"12px"}
                        right={"12px"}
                        padding={"10px"}
                        zIndex={4}
                        onPress={() => {
                          handleConfirmDelete(media);
                        }}
                      >
                        <CloseIcon color={"black"} size={"12px"} />
                      </Pressable>

                      {media?.orgFile?.startsWith("GoogleDrive") ? (
                        <iframe
                          key={media?.id || i}
                          width={260}
                          style={{ borderRadius: 10 }}
                          height={160}
                          src={media?.linkURL}
                          title=""
                        ></iframe>
                      ) : media?.type?.startsWith("video") ? (
                        <video controls width={260} height={160}>
                          <source src={media?.linkURL} type="video/mp4" />
                        </video>
                      ) : (
                        <img
                          width={260}
                          height={160}
                          style={{ borderRadius: 10 }}
                          src={
                            media?.type === "dropbox"
                              ? media?.orgFile
                              : media?.linkURL
                          }
                          key={media?.id || i}
                          alt=""
                        />
                      )}
                    </HStack>
                  ))}
              </Box>
            )}
          </HStack>
        )}
      </div>
    </>
  );
};

export default CreatePostGrid;
